import './product-cards.scss';

class ProductCards {
    constructor (element) {
        this.$productCard = element;
        this.$itemsTo1 = element.querySelectorAll('[data-product-cards-pos="1"]');
        this.$itemsTo2 = element.querySelectorAll('[data-product-cards-pos="2"]');
        this.$content1 = element.querySelector('[data-product-cards-content="1"]');
        this.$content2 = element.querySelector('[data-product-cards-content="2"]');
        this.$processSelect = element.querySelector('[data-product-cards="process-select"]');
        this.$processViewButton = this.$processSelect?.querySelector('[data-product-cards="process-view"]');
        this.$$selectedProcesses = this.$productCard.querySelectorAll('input[type="checkbox"]:checked');
        this.buttonDisabled = true;
    }

    initialize () {
        this.toggleVersion();
        this.checkSize();
        this.toggleDisabledState();
        this.setEvents();
    }

    moveIn () {
        this.$itemsTo1.forEach(($item) => {
            this.$content1.appendChild($item);
        });

        this.$itemsTo2.forEach(($item) => {
            this.$content2.appendChild($item);
        });
    }

    moveOut () {
        this.$itemsTo1.forEach(($item) => {
            this.$productCard.insertBefore($item, this.$content2);
        });

        this.$itemsTo2.forEach(($item) => {
            this.$productCard.insertBefore($item, this.$content2);
        });
    }

    checkSize () {
        if (window.mediaMatchHandler[1280].matches) {
            this.moveIn();
        }

        window.mediaMatchHandler[1280].addEventListener('change', (match) => {
            if (!match.matches) {
                this.moveOut();
            }

            if (match.matches) {
                this.moveIn();
            }
        });
    }

    viewProcesses () {
        const isValidURL = (value) => {
            try {
                const url = new URL(value); // eslint-disable-line
                return true;
            } catch (e) {
                return false;
            }
        };

        this.$$selectedProcesses.forEach($selectedProcess => {
            const isValidUrl = isValidURL($selectedProcess.value);
            if (isValidUrl) {
                window.open($selectedProcess.value, '_blank');
            }
        });
    }

    toggleVersion () {
        if (window.popupBlockerActive) {
            this.$productCard.setAttribute('data-popupblocker-activated', '');
        }
    }

    toggleDisabledState () {
        if (this.buttonDisabled) {
            if (this.$$selectedProcesses.length > 0) {
                this.buttonDisabled = false;
                this.$processViewButton.classList.remove('button--disabled');
                this.$processViewButton.disabled = false;
            }
        } else {
            if (this.$$selectedProcesses.length === 0) {
                this.buttonDisabled = true;
                this.$processViewButton.classList.add('button--disabled');
                this.$processViewButton.disabled = true;
            }
        }
    }

    setEvents () {
        if (this.$processSelect) {
            this.$processSelect.addEventListener('change', () => {
                this.$$selectedProcesses = this.$productCard.querySelectorAll('input[type="checkbox"]:checked');
                this.toggleDisabledState();
            });

            if (this.$processViewButton && !window.popupBlockerActive) {
                this.$processViewButton.addEventListener('click', () => {
                    this.viewProcesses();
                });
            }
        }
    }
}

export { ProductCards };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $productCards = $context.querySelectorAll('[data-product-cards="item"]');

        if ($productCards.length > 0) {
            $productCards.forEach($productCard => {
                $productCard = new ProductCards($productCard);
                $productCard.initialize();
            });
        }
    }
});
